import './radioBox.scss';

import cn from 'classnames';
import { motion } from 'framer-motion';
import React, { ReactElement, useCallback, useEffect, useState } from 'react';

import { useThemeColors } from '@/shared/theme';

interface IRadioBoxProps {
  text: string;
  renderText?: (text: string) => JSX.Element;
  className?: string;
  checked: boolean;
  onChange?: () => void;
  pairIcon?: ReactElement;
}

const RadioBox: React.FC<IRadioBoxProps> = ({
  text,
  renderText,
  className,
  checked,
  onChange,
  pairIcon,
}) => {
  const palette = useThemeColors();

  const [checkedInner, setCheckedInner] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleChange = useCallback((): void => {
    if (onChange) onChange();
  }, [onChange]);

  useEffect(() => {
    setCheckedInner(checked);
  }, [checked]);

  return (
    <div
      className={cn('mm-radio-box', { [className || '']: className })}
      onClick={handleChange}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <input type="radio" checked={checkedInner} onChange={handleChange} />
      {!renderText && (
        <>
          {pairIcon}
          <motion.span
            animate={{
              color: checked || isHovered ? palette.primary : palette.gray_1,
            }}
            className="mm-radio-box__text"
          >
            {text}
          </motion.span>
        </>
      )}
      {renderText && renderText(text)}
    </div>
  );
};

export { RadioBox };
